import React from 'react';
import {
  hasAdministrationRights,
  hasInstructorRights,
  isPocOrFactoryLeadInExtendedWf,
  isPoCAndEventStatusInPlannedOrInProgress
} from 'utils/event-utils';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';

interface Props {
  eventFormStore: EventFormStore;
  readOnlyForPocs: boolean;
  onEdit?: () => void;
  onSave?: () => void;
}

const EventEditPocButtonTw: React.FC<Props> = ({ eventFormStore, readOnlyForPocs, onEdit, onSave }) => {
  const event: EventFormViewModel = eventFormStore.state.item;
  if (!event) return null;

  const canEdit = () => hasAdministrationRights(event) || hasInstructorRights(event) || isPocOrFactoryLeadInExtendedWf(event);

  const isVisible = !canEdit() && isPoCAndEventStatusInPlannedOrInProgress(event);
  if (!isVisible) return null;

  return readOnlyForPocs ? (
    <button
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      onClick={onEdit}
    >
      Edit (POC)
    </button>
  ) : (
    <button
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      onClick={onSave}
    >
      Save (POC)
    </button>
  );
};

export default EventEditPocButtonTw;
